.PhoneNumberInput {
  display: flex;

  .phoneInput {
    line-height: 2em; // fixed PD-8447
  }

  .dropdown {
    padding: 0 0 0 $padding-xxsmall;
    border: 1px solid var(--border, #{$color-border});
    border-top-left-radius: $border-radius-button-base;
    border-bottom-left-radius: $border-radius-button-base;
    border-right: 0;
    background-color: var(--bg-surface-raised, #{$color-white});
    flex: 1 0 auto;
    color: var(--text-heading, inherit);

    input.search {
      display: none;
    }

    .dropdown-input {
      padding: $padding-xsmall $padding-small $padding-xxsmall $padding-small;
    }
  }

  .PhoneNumberInput__Toggle {
    height: 34px;
    display: flex;
    align-items: center;
    color: var(--text-heading, inherit);

    > * {
      flex: 1 0 auto;
      display: flex;
    }

    .Icon {
      font-size: 20px;
      color: var(--text-paragraph-2, #{$color-base});
    }

    img {
      width: 20px;
      height: 20px;
      margin: 0 $gutter-xxsmall;
    }
  }

  input[type="text"] {
    flex: 1 1 auto;
    padding-left: $padding-xxxsmall;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0 !important;
  }
}

.dark .PhoneNumberInput {
  .dropdown {
    background-color: var(--card, #09090B) !important;
    border-color: var(--border, #{$theme-dark-border}) !important;
    color: var(--text-heading, #FAFAFA) !important;
  }

  .PhoneNumberInput__Toggle {
    color: var(--text-heading, #FAFAFA);

    .Icon {
      color: var(--text-paragraph-2, #A1A1AA);
      @include iconColor(#A1A1AA);
    }
  }

  // Beat any leftover light Form__control / Semantic fills on the number field
  .phoneInput.Form__control,
  input.phoneInput[type="text"],
  input[type="text"].Form__control {
    background-color: var(--card, #09090B) !important;
    border-color: var(--border, #{$theme-dark-border}) !important;
    color: var(--text-heading, #FAFAFA) !important;
    -webkit-text-fill-color: var(--text-heading, #FAFAFA) !important;

    &::placeholder {
      color: var(--text-paragraph-2, #A1A1AA) !important;
      -webkit-text-fill-color: var(--text-paragraph-2, #A1A1AA) !important;
      opacity: 1;
    }
  }
}
